import { ArrowRight, Phone, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { STUDIO } from "@/content";
import { SITE } from "@/constants/testIds";
import { WhatsappIcon } from "./WhatsappIcon";

export const Hero = () => (
  <section id="top" className="relative pt-20 overflow-hidden bg-white">
    <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 pt-14 md:pt-20 pb-20 md:pb-28">
      <div className="lg:col-span-7 flex flex-col justify-center">
        <p className="inline-flex self-start items-center gap-2 rounded-full bg-navy-50 px-4 py-2 text-xs font-semibold text-navy-900 animate-rise">
          <span className="h-2 w-2 rounded-full bg-bronze" /> Studio Legale a Latina · per imprese e privati
        </p>
        <h1 className="mt-7 text-[2.3rem] sm:text-5xl lg:text-[3.6rem] font-extrabold tracking-[-0.03em] leading-[1.05] text-navy-900 animate-rise [animation-delay:120ms]">
          Il tuo legale, dalla persona all'impresa.
          <br />
          <span className="text-bronze-600">Dall'inizio alla fine.</span>
        </h1>
        <p className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-navy-500 animate-rise [animation-delay:240ms]">
          Consulenza legale chiara e veloce, senza giri di parole. «Seguo personalmente ogni pratica, dall'inizio alla
          fine»: un solo referente, preventivi trasparenti e risposte rapide, anche nei casi urgenti.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 animate-rise [animation-delay:480ms]">
          <Button asChild data-testid={SITE.heroBookBtn} className="group rounded-full bg-navy-900 hover:bg-navy-700 h-14 px-7 text-sm font-semibold tracking-wide transition-colors">
            <a href="#prenota">
              Prenota un appuntamento
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </Button>
          <Button asChild variant="outline" data-testid={SITE.heroCallBtn} className="rounded-full h-14 px-6 border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white text-sm font-semibold transition-colors">
            <a href={STUDIO.phoneHref}>
              <Phone className="mr-2 h-4 w-4" /> Chiama lo studio
            </a>
          </Button>
          <Button asChild variant="outline" data-testid={SITE.heroWhatsappBtn} className="rounded-full h-14 px-6 border-whatsapp-dark bg-whatsapp-dark text-white hover:bg-whatsapp hover:border-whatsapp hover:text-white text-sm font-semibold transition-colors">
            <a href={STUDIO.whatsappHref} target="_blank" rel="noopener noreferrer">
              <WhatsappIcon className="mr-2 h-4 w-4" /> WhatsApp
            </a>
          </Button>
        </div>
      </div>

      <div className="lg:col-span-5 relative animate-rise [animation-delay:300ms]">
        <div className="absolute -top-6 -right-6 w-40 h-40 rounded-3xl bg-bronze-100 hidden md:block" aria-hidden />
        <div className="relative rounded-[2rem] bg-navy-900 aspect-[4/5] flex flex-col items-center justify-center px-10 overflow-hidden">
          <img src="/brand/monogram-white.png" alt="" aria-hidden className="absolute -bottom-16 -left-16 w-[85%] opacity-[0.06]" />
          <img src="/brand/logo-white.png" alt="Studio Legale D'Arienzo" className="relative w-[78%] max-w-[340px]" />
          <div className="relative mt-12 h-px w-16 bg-bronze" />
          <p className="relative mt-6 text-center text-xs uppercase tracking-[0.3em] text-navy-100">Avv. Federico D'Arienzo</p>
        </div>
        <div className="relative -mt-10 mx-6 md:mx-10 rounded-2xl bg-white border border-navy-100 p-6 shadow-[0_20px_40px_rgba(0,43,74,0.08)] flex gap-4 items-start">
          <MapPin className="h-5 w-5 text-bronze shrink-0 mt-0.5" />
          <div className="text-sm text-navy-900">
            <p className="font-semibold">{STUDIO.address}</p>
            <p className="text-navy-500">{STUDIO.city} · Ricevimento su appuntamento</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
